/* eslint-disable */
/* global Office */
import React, { Component } from "react";
import "office-ui-fabric-react/dist/css/fabric.css";
import { Button, ButtonType } from "office-ui-fabric-react";
import "office-ui-fabric-core/dist/css/fabric.css";
import { Link } from "react-router-dom";
import "./header-styles.scss";
import utils from "./../../utils/utils";
import { ToastContainer, toast } from "react-toastify";
import Profile from "./../../assets/profile.png";

export class Header extends Component {
  constructor() {
    super();
    this.state = {
      showMenu: false,
    };
  }

  userLogout = () => {
    utils.logout();
  };

  render() {
    var that = this;

    return (
      <div ref={(elem) => (this.userMenu = elem)} className="ms-Grid-row">
        <ToastContainer bodyClassName="toast-body" draggable={false} hideProgressBar={true} autoClose={3000} toastClassName="dark-toast" position={toast.POSITION.TOP_RIGHT} />
        {this.props.type !== "user-loggedout" && (
          <React.Fragment>
            <div className="ms-Grid-row header">

              <div className="header-left">
                {this.props.backButton ? (
                  <Link to={this.props.backButton.to} style={{ textDecoration: "none" }}>
                    <Button className="navigation-button back-button" buttonType={ButtonType.primary}>
                      <i className="ms-Icon ms-Icon--Back" aria-hidden="true"></i> {this.props.backButton.title}
                    </Button>
                  </Link>
                ) :
                  <>{this.props.title && <div className="header-title">{this.props.title}</div>}</>
                }
              </div>

              <div className="ms-Grid-col user-image-section " onClick={() => { this.setState({ showMenu: !that.state.showMenu }) }}>
                <img
                  style={{ height: 30, width: 30, borderRadius: "50%" }}
                  alt={JSON.parse(localStorage.getItem("userData")).name}
                  src={
                    localStorage.getItem("userImage") !== "" && localStorage.getItem("userImage") !== null
                      ? "data:image/jpeg;base64," + JSON.parse(localStorage.getItem("userImage")).data
                      : Profile
                  }
                />
                <i className="ms-Icon ms-Icon--CaretDownSolid8 user-dropdown-arrow" style={{ fontSize: 20 }} aria-hidden="true"></i>
              </div>
            </div>

            {that.state.showMenu && (
              <div className="divClass user-dropdown-menu fright dropdown">
                <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                  <li>
                    <div className="userList">
                      <div className="details-user">
                        <p className="userName">
                          <strong>{JSON.parse(localStorage.getItem("userData")).name}</strong>
                        </p>
                        <p className="userEmail">{JSON.parse(localStorage.getItem("userData")).email}</p>
                      </div>
                    </div>
                  </li>
                  <li className="userList-values-container" onClick={this.userLogout}>
                    <div className="userList-values">
                      <span className="list-Values">
                        <i className="ms-Icon ms-Icon--SignOut" style={{ fontSize: 20, marginRight: 10 }} aria-hidden="true"></i>SignOut
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Header;